export enum PostStatus {
    LIVE,
    DISCARDED,
    ABUSE,
    UNKNOWN,
    TESTING,
    POSTLIVE
}